import {IntermediatePart} from "../../intermediatePart";

export default class SplitWall extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'split_wall';
    this.partName = 'Split Wall';
    this.translateId = "visualizer.bathroom.walls.split_wall";
    this.activeFeatureBeforeAllWalls = null;
    this.allWallsApplied = true;
    this.isStoneFeature = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new SplitWall());
  }
}
